<script lang="ts">
  import type { Snippet } from 'svelte'
  import Icon from './Icon.svelte'

  interface Props {
    icon?: string
    tone?: 'default' | 'danger'
    checked?: boolean
    onclick: () => void
    children: Snippet
  }
  const { icon, tone = 'default', checked, onclick, children }: Props = $props()
</script>

<button class="item {tone}" role="menuitem" {onclick}>
  {#if icon}<Icon name={icon} size={18} />{/if}
  <span class="label">{@render children()}</span>
  {#if checked}<Icon name="check" size={16} />{/if}
</button>

<style>
  .item {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    width: 100%;
    min-height: 42px;
    padding: 0 var(--space-3);
    border: none;
    border-radius: var(--radius-sm);
    background: transparent;
    text-align: left;
    color: var(--fg);
  }
  .item:hover {
    background: var(--surface-2);
  }
  .danger {
    color: var(--danger);
  }
  .label {
    flex: 1;
  }
</style>
